export const PRIVACY_CLASS = {
  none: "None",
  personal: "Personal Data",
  sensitive: "Sensitive Data",
};

export const SECURITY_CLASS = {
  general: "General Business",
  confidential: "Confidential",
  highlyConfidential: "Highly Confidential",
};

export const PRIVACY_CLASS_VALUES = {
  none: "none",
  personal: "personal",
  sensitive: "sensitive"
}

export const SECURITY_CLASS_VALUES = {
  general: "general",
  confidential: "confidential",
  highlyConfidential: "highly_confidential"
};

export const CONNECTION_TYPES = {
  s3Buckets: "S3 Buckets",
  oracle: "Oracle",
  windowsFileshare: "Windows Fileshare",
  postGres: "Postgres",
  redShift: "Redshift",
  mssql: "MSSQL",
  azure: "ADLS",
  extSpoke: "EXT Connection",
  lndspoke: "Landing Connection",
  hstgspoke: "History Connection",
  foundry: "Foundry",
};

export const TEST_CONNECTION_TYPES = {
  oracle: "Oracle",
  postGres: "PostgreSql",
  mssql: "AzureSqlDatabase",
  redShift: "AmazonRedshift",
};

export const EXTRACT_TYPES = {
  s3Buckets: "EXTRACT_S3",
  adls: "EXTRACT_ADLS",
  mssql: "EXTRACT_MSSQL",
  windowsFileshare: "EXTRACT_WFS",
  postGres: "EXTRACT_POSTGRES",
  oracle: "EXTRACT_ORACLE",
  redShift: "EXTRACT_REDSHIFT",
  azure: "EXTRACT_AZURE",
  fileSystem: "EXTRACT_FILESYSTEM",
  foundry: "EXTRACT_FOUNDRY"
};

export const LOAD_TYPES = {
  s3Buckets: "LOAD_S3",
  adls: "LOAD_ADLS",
  mssql: "LOAD_MSSQL",
  windowsFileshare: "LOAD_WFS",
  postGres: "LOAD_POSTGRES",
  oracle: "LOAD_ORACLE",
  redShift: "LOAD_REDSHIFT",
  azure: "LOAD_AZURE",
};

export const S3_SECRET_TYPES = {
  accesskey: "Access Key",
  secretAccess: "Secret Access Key",
};

export const CONN_STRING_TYPE = {
  app: "App",
  synapse: "Synapse",
};

export const TRIGGER_TYPES = {
  timeBased: "Time-based",
  dataExtractor: "Data Extractor",
  dataLoader: "Data Loader",
  inboundWebhook: "Webhook",
};

export const ACTION_TYPES = {
  outboundWebhook: "Outbound Webhook",
};

export const SCREEN_TYPES = {
  target: "target",
  source: "source",
};

export const TREATMENT_LABElS = {
  low: "Low",
  medium: "Medium",
  high: "High",
  veryHigh: "Very High",
  access: "Access"
};

export const TREATMENT_VALUES = {
  low: "low",
  medium: "medium",
  high: "high",
  veryHigh: "very-high",
  access: "access"
};

export const MODE = {
  add: "Add",
  edit: "Edit",
  view: "View",
  delete: "Delete",
};

export const IDP_PROD_USERS = "IDP Users Production";

export const TEST_SOURCEID = 9638;

export const timeZoneValues = [
  "-12:00 UTC",
  "-11:00 UTC",
  "-10:00 UTC",
  "-09:30 UTC",
  "-09:00 UTC",
  "-08:00 UTC",
  "-07:00 UTC",
  "-06:00 UTC",
  "-05:00 UTC",
  "-04:00 UTC",
  "-03:30 UTC",
  "-03:00 UTC",
  "-02:00 UTC",
  "-01:00 UTC",
  "+00:00 UTC",
  "+01:00 UTC",
  "+02:00 UTC",
  "+03:00 UTC",
  "+03:30 UTC",
  "+04:00 UTC",
  "+04:30 UTC",
  "+05:00 UTC",
  "+05:30 UTC",
  "+05:45 UTC",
  "+06:00 UTC",
  "+06:30 UTC",
  "+07:00 UTC",
  "+08:00 UTC",
  "+08:30 UTC",
  "+08:45 UTC",
  "+09:00 UTC",
  "+10:00 UTC",
  "+10:30 UTC",
  "+11:00 UTC",
  "+12:00 UTC",
  "+12:45 UTC",
  "+13:00 UTC",
  "+14:00 UTC",
];

export const criticalities = [
  {
    level: "1",
    title: "Criticality Level 1",
    value: 1,
    application: "Criticality Application",
    availability: "Target Availability 24hrs X 7 days",
    upTime: "Target Up Time 99.20%",
  },
  {
    level: "2",
    title: "Criticality Level 2",
    value: 2,
    application: "Very Important To Business",
    availability: "Target availability 24hrs X 7days",
    upTime: "98.90%",
  },
  {
    level: "3",
    title: "Criticality Level 3",
    value: 3,
    application: "Very Important To Business",
    availability: "Target availability 24hrs X 7days",
    upTime: "98.40%",
  },
  {
    level: "4",
    title: "Criticality Level 4",
    value: 4,
    application: "Somewhat Important To Business",
    availability: "Target availability 24hrs X 7days",
    upTime: "98.10%",
  },
  {
    level: "5",
    title: "Criticality Level 5",
    value: 5,
    application: "Somewhat Important To Business",
    availability: "Target availability 24hrs X 7days",
    upTime: "97.80%",
  },
  {
    level: "6",
    title: "Criticality Level 6",
    value: 6,
    application: "Low Impact From Any Outage",
    availability: "Target availability 24hrs X 7days",
    upTime: "94.60%",
  },
];

export const REQUEST_STATUS = {
  awaiting_review: "Awaiting Admin Review",
  requested: "Requested",
  awaiting_approval: "Awaiting Data Steward Approval",
  approved: "Approved",
  rejected: "Rejected",
  completed: "Completed",
  cancelled: "Cancelled",
  pending_notification: "Pending Data Steward Notification",
  pending_completion: "Pending Approved Request Completion"
};

export const REQUEST_STATUS_VALUES = {
  awaiting_review: "awaiting review",
  requested: "requested",
  awaiting_approval: "awaiting approval",
  approved: "approved",
  rejected: "rejected",
  completed: "completed",
  cancelled: "cancelled",
  pending_notification: "pending approver notification",
  pending_completion: "pending approved request completion"
};